import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import MainLayout from "./components/MainLayout";
import LandingPage from "./pages/LandingPage";
import Contact from "./pages/ContactPage/Contact";
import StartUps from "./pages/StartUpsPage/StartUps";
import OEMs from "./pages/OEMPage/OEMs";
import Design from "./pages/DesignPage/Design";
import Manufacturing from "./pages/ManufacturingPage/Manufacturing";
import Expertise from "./pages/ExpertisePage/Expertise";
import PrototypeSprint from "./pages/PrototypePage/PrototypeSprint";
import Privacy from "./pages/PrivacyPage/Privacy";
import Products from "./pages/ProductPage/Products";
// import ProductDetails from "./pages/ProductPage/ProductDetails";
import About from "./pages/About/About";
import ProductInfo from "./pages/ProductPage/ProductInfo";
import SearchProducts from "./pages/ProductPage/SearchProducts";
import NotFound from "./pages/ProductPage/NotFound";


const ScrollToTop = () => {
  const location = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);
  return null;
};

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<MainLayout />}>
          <Route path="/" element={<LandingPage />} />
          <Route path="/about" element={<About />} />
          <Route path="/startups" element={<StartUps />} />
          <Route path="/oems" element={<OEMs />} />
          <Route path="/designs" element={<Design />} />
          <Route path="/contact-us" element={<Contact />} />
          <Route path="/manufacturing" element={<Manufacturing />} />
          <Route path="/expertise" element={<Expertise />} />
          <Route path="/prototype-sprint" element={<PrototypeSprint />} />
          <Route path="/privacy-policy" element={<Privacy />} />
          <Route path="/products" element={<Products />} />
          {/* <Route path="/product/:model" element={<ProductDetails />} /> */}
          <Route path="/product/:model" element={<ProductInfo />} />
          <Route path="/product/*" element={<SearchProducts />} />
          <Route path="*" element={<NotFound />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
